import { render, staticRenderFns } from "./Layerpopup.vue?vue&type=template&id=3dbbef32&scoped=true"
import script from "./Layerpopup.vue?vue&type=script&lang=js"
export * from "./Layerpopup.vue?vue&type=script&lang=js"
import style0 from "./Layerpopup.vue?vue&type=style&index=0&id=3dbbef32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbbef32",
  null
  
)

export default component.exports